import { render, staticRenderFns } from "./delivery.vue?vue&type=template&id=34a5473a&scoped=true&"
import script from "./delivery.vue?vue&type=script&lang=js&"
export * from "./delivery.vue?vue&type=script&lang=js&"
import style0 from "./delivery.vue?vue&type=style&index=0&id=34a5473a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a5473a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34a5473a')) {
      api.createRecord('34a5473a', component.options)
    } else {
      api.reload('34a5473a', component.options)
    }
    module.hot.accept("./delivery.vue?vue&type=template&id=34a5473a&scoped=true&", function () {
      api.rerender('34a5473a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/calculations/create/tabs/delivery.vue"
export default component.exports